"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Roles";

export default {
  getAllRolesData() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllRolesData`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  save(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/Save`, payload).result.then(({ data }) => {
        resolve(data);
      });
    });
  },
  getOneRoleData(roleId) {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetOneRoleData`, `?roleID=${roleId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  deleteRole(roleId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/DeleteRole?roleID=${roleId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
